import { JarvisWebHttpClient } from '@jarvis/web-http'
import { getPswApiStack } from '../utils'

class PSWApiClient {
  constructor(stack, clientId, pswApiUrl = null) {
    ;(this.jarvisWebHttpInstance = new JarvisWebHttpClient()),
      (this.stack = stack),
      (this.clientId = clientId),
      (this.pswApiUrl = pswApiUrl)
  }

  /**
   * @param {string} endpoint
   * @returns {string}
   */
  _buildApiUrl(endpoint) {
    return `${this.pswApiUrl || getPswApiStack(this.stack)}${endpoint}`
  }

  /**
   * @param {string} url
   * @returns {Promise<any>}
   */
  async _getClient(url) {
    return await this.jarvisWebHttpInstance.get({
      url,
      headers: {
        'x-hp-client-id': this.clientId
      }
    })
  }

  /**
   * @param {string} query
   * @returns {Promise<any>}
   */
  async searchDevices(query) {
    const apiUrl = this._buildApiUrl(`/api/v1/typeahead?query=${query}`)
    const response = await this._getClient(apiUrl)
    return response
  }

  /**
   * @param {{ sku: string, os: string }} params
   * @returns {Promise<any>}
   */
  async fetchBasicDrivers({ sku, os }) {
    if (!sku || !os) {
      throw new Error('fetchBasicDrivers requires sku and os')
    }

    const apiUrl = this._buildApiUrl(
      `/api/v1/software/${sku}?os=${encodeURIComponent(os)}`
    )
    return this._getClient(apiUrl)
  }

  /**
   * @returns {Promise<any>}
   */
  async getDeviceSearchList() {
    const apiUrl = this._buildApiUrl('/api/v1/searchList')
    const response = await this._getClient(apiUrl)
    return response
  }

  /**
   * @param {string} sku
   * @param {string} language
   * @param {string} country
   * @param {string | null} pageType
   * @returns {Promise<any>}
   */
  async getHpSupportRedirect(sku, language, country, pageType = null) {
    if (!sku || !language || !country) {
      throw new Error(
        'getHpSupportRedirect requires sku, language, and country'
      )
    }

    const searchParams = new URLSearchParams({
      sku,
      l: language,
      c: country
    })

    if (pageType) {
      searchParams.set('pageType', pageType)
    }

    const apiUrl = this._buildApiUrl(
      `/api/v1/hp-support/redirect?${searchParams.toString()}`
    )

    return this._getClient(apiUrl)
  }

  /**
   * @param {{sku: string}} sku
   * @returns {Promise<any>}
   */
  async fetchImageBySkuInHermes({ sku }) {
    const width = 700
    const height = 400
    const apiUrl = this._buildApiUrl(
      `/api/v1/images/${sku}?width=${width}&height=${height}`
    )
    const response = await this._getClient(apiUrl)
    const { imageUrl } = await response.data

    console.info('[IMAGE FLOW] Returning image URL from Hermes API')
    return imageUrl
  }
}

export default PSWApiClient
